import { documentV2Contract } from "@clipboard-health/contract-documents-service";
import { patch } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import {
  DOCUMENT_EVIDENCES_QUERY_KEY,
  WORKER_EVIDENCES_QUERY_KEY,
} from "@src/appV2/redesign/Evidence/constants";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { type z } from "zod";

import { getWorkerDocumentsQueryKey } from "./useGetWorkerDocuments";

const bodySchema = documentV2Contract.update.body;
const responseSchema = documentV2Contract.update.responses[200];

export type UpdateWorkerDocumentV2Body = z.input<typeof bodySchema>;
export type UpdateWorkerDocumentV2Response = z.output<typeof responseSchema>;

export interface UpdateWorkerDocumentV2Params {
  id: string;
  body: UpdateWorkerDocumentV2Body;
}

export function useUpdateWorkerDocumentV2() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }: UpdateWorkerDocumentV2Params) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL}/v2/documents/${id}`,
        data: body,
        bodySchema,
        responseSchema,
      });
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: getWorkerDocumentsQueryKey() });
      void queryClient.invalidateQueries({ queryKey: [WORKER_EVIDENCES_QUERY_KEY] });
      void queryClient.invalidateQueries({ queryKey: [DOCUMENT_EVIDENCES_QUERY_KEY] });
    },
    meta: { logErrorMessage: APP_V2_APP_EVENTS.UPDATE_WORKER_DOCUMENT_FAILURE },
  });
}
